module.exports = __webpack_public_path__ + "img/poligrafo.fe1aca3a.png";